import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import { get, getOr } from "lodash/fp";
import { RedirectButton } from "../../Components/Form";
import { FontBold } from "../../Components/Auth/Layout";
import useHeaderComponentsMutation from "../../Hooks/useHeaderComponentsMutation";
import Loader from "../../Components/Loader";
import Search from "../../Components/Search/Index";
import { EVENT_TITLE } from "../../Constants/AppConstants";
import { FETCH_EVENT_COACHES } from "../../GraphQL/Queries";
import useCurrentUser from "../../Hooks/userCurrentUser";
import useUserSearch from "../../Hooks/useUserSearch";
import {
  sortSelectStyle,
  filterAndSortUsers,
  formatJoinedAt,
} from "../../Hooks/eventUsersUtils";
import userDefaultImage from "../../Images/icons/userIcon.png";
import UserList from "../../Components/UserList/Index";
import RIGHT_ARROW from "../../Images/icons/right-color-arrow.png";

const Coaches = () => {
  const { currentUser } = useCurrentUser(true);
  const searchList = useUserSearch();
  const { id } = useParams();
  const [searchValue, setSearchValue] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");
  const [fetchCoaches, { data: coachesData, loading: coachesLoading }] =
    useLazyQuery(FETCH_EVENT_COACHES);
  const coaches = getOr([], "eventCoaches", coachesData);
  const filteredCoaches = filterAndSortUsers(
    coaches,
    searchValue,
    sortOrder,
    searchList,
  );

  useEffect(() => {
    if (currentUser) {
      fetchCoaches({
        variables: {
          eventId: id,
        },
      });
    }
  }, [currentUser, fetchCoaches, id]);

  const searchCoach = (e) => {
    setSearchValue(e.target.value);
  };

  const onSortChange = (e) => {
    setSortOrder(e.target.value);
  };
  useHeaderComponentsMutation({
    title: "COACHES",
    backLink: `/event-manage/${id}`,
    components: [
      { key: EVENT_TITLE, value: get("[0].fetchEvent.title", filteredCoaches) },
    ],
  });

  return (
    <>
      <div className="mt-4" />
      <div className="row">
        <div className="col-md-6 col-12">
          <RedirectButton
            backgroundcolor="#F4AB37"
            fontColor="#FFF"
            border="none"
            addNewText="INVITE USER"
            addNewLink={`/event-manage/${id}/invite-existing-user/coach`}
          />
        </div>
        <div className="col-md-6 col-12">
          <RedirectButton
            backgroundcolor="#FFF"
            fontColor="rgba(244, 171, 55, 1)"
            border="2px solid #f3AA44"
            addNewText="INVITE NEW USER"
            addNewLink={`/event-manage/${id}/invite-new-user/coach`}
          />
        </div>
      </div>
      <div className="mt-4" />
      <Search placeholder="Search" onChange={searchCoach} />
      <div className="row mt-3">
        <div className="col-auto ml-auto px-4">
          <select
            id="coach-sort-order"
            className="form-control"
            style={sortSelectStyle}
            value={sortOrder}
            onChange={onSortChange}
          >
            <option value="latest">Latest Joined</option>
            <option value="earliest">Earliest Joined</option>
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mx-auto px-4">
          <FontBold>
            <p className="mt-4">
              Coaches(
              {filteredCoaches.length})
            </p>
          </FontBold>
        </div>
      </div>
      {coachesLoading ? (
        <Loader />
      ) : (
        filteredCoaches.map((eventUser) => (
          <>
            <div key={eventUser.id}>
              <UserList
                user={get("fetchUser", eventUser)}
                imageAttached={userDefaultImage}
                arrowIcon={RIGHT_ARROW}
                redirectLink={`/event-manage/${id}/event-user-profile/${get("id", get("fetchUser", eventUser))}`}
                joinedAt={formatJoinedAt(get("createdAt", eventUser))}
              />
            </div>
          </>
        ))
      )}
    </>
  );
};
export default Coaches;
